import { useEffect, useReducer, useState, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import axios from 'axios';
import { getReducer } from '../../../utils';

import './css/listmember.css';
import LoadingBox from '../../compoment/LoadingBox';
import MessageBox from '../../compoment/MessageBox';
import { formatYear } from '../../../format/formatDate';
import Breadcrumb from '../../layouts/Breadcrumb';
import Member from './compoments/Member';
import { Store } from '../../../Store';
import Pagination from '../../compoment/Pagination';

const listSort = [
  { id: 0, title: 'Phù hợp' },
  { id: 1, title: 'Mới nhất' },
  {
    id: 2,
    title: 'Ngày cập nhật',
  },

  // { id: 2, title: 'Hot nhất' },
];

const reducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_REQUEST':
      return { ...state, loading: true };
    case 'FETCH_SUCCESS':
      return { ...state, members: action.payload, loading: false };
    case 'FETCH_FAIL':
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

const ListMemberScreen = () => {
  const [{ loading, error, members }, dispatch] = useReducer(
    getReducer(reducer),
    {
      members: null,
      loading: true,
      error: '',
    }
  );

  const MAX_LENGHT_LIMIT = 50;

  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { userInfo } = state;

  const navigate = useNavigate();

  const location = useLocation();

  const [openIds, setOpenIds] = useState(new Set());
  const [sortOption, setSortOption] = useState(0);
  const [pageIndex, setPageIndex] = useState(1);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // mobile breakpoint

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (!userInfo || !userInfo.token) {
      navigate('/');
      return;
    }
    const fetchData = async () => {
      const urlParams = new URLSearchParams(location.search);

      dispatch({ type: 'FETCH_REQUEST' });
      try {
        const result = await axios.get(
          `/user/advanced-search?${
            urlParams ? urlParams.toString() + '&' : ''
          }page=${pageIndex}&limit=${MAX_LENGHT_LIMIT}`,
          {
            headers: {
              Authorization: `Bearer ${userInfo.token}`,
            },
          }
        );

        ctxDispatch({
          type: 'SET_TOTALSEARCH',
          payload: result.data.data.totalItems,
        });
        localStorage.setItem(
          'totalSearch',
          JSON.stringify(result.data.data.totalItems)
        );

        dispatch({ type: 'FETCH_SUCCESS', payload: result.data.data });
      } catch (err) {
        const errorMessage =
          err?.response?.status === 422
            ? err.response.data?.messages
            : err.message;

        dispatch({ type: 'FETCH_FAIL', payload: errorMessage });
      }
    };
    fetchData();
  }, [userInfo, pageIndex, ctxDispatch, location.search]);

  return loading ? (
    <LoadingBox />
  ) : error ? (
    <MessageBox variant={!error.user && 'danger'}>
      {error.user ? error.user : error}{' '}
    </MessageBox>
  ) : (
    <div>
      <Breadcrumb />
      <section className="container mb-md-4 mb-3">
        <div className="bg-white shadow-lg list-member">
          <div className="page-search-sort">
            <h5>
              Tìm thấy <span>{members.totalItems}</span> thành viên mới nhất{' '}
              {formatYear(new Date())}
            </h5>
            <div className="sort-wrapper">
              <span className="label-sort">Sắp xếp theo:</span>

              {isMobile ? (
                <select
                  className="form-select"
                  value={sortOption}
                  onChange={(e) => setSortOption(parseInt(e.target.value))}
                >
                  {listSort.map((item, idx) => (
                    <option key={idx} value={idx}>
                      {item.title}
                    </option>
                  ))}
                </select>
              ) : (
                <div className="btn-group_radios">
                  {listSort.map((item, idx) => (
                    <label key={idx} className="btn-group_radio">
                      <input
                        type="radio"
                        name="sortOption"
                        value={idx}
                        checked={sortOption === idx}
                        onChange={(e) =>
                          setSortOption(parseInt(e.target.value))
                        }
                        className="filter-tab"
                      />
                      <span>{item.title}</span>
                    </label>
                  ))}
                </div>
              )}
            </div>
          </div>
          <article className="w-100 mt-3">
            {members.users.length > 0 ? (
              members.users
                .filter(
                  (user) =>
                    user.status === 'active' && user.username !== 'admin'
                )
                .sort((a, b) => {
                  switch (sortOption) {
                    case 2: // Ngày cập nhật
                      return new Date(b.updatedAt) - new Date(a.updatedAt);
                    case 1: // Ngày đăng
                      return new Date(b.createdAt) - new Date(a.createdAt);
                    default:
                      return 0;
                  }
                })
                .map((user, idx) => (
                  <Member
                    key={idx}
                    user={user}
                    isOpen={openIds.has(user.id)}
                    toggleOpen={() => {
                      setOpenIds((prev) => {
                        const newSet = new Set(prev);
                        if (newSet.has(user.id)) {
                          newSet.delete(user.id);
                        } else {
                          newSet.add(user.id);
                        }
                        return newSet;
                      });
                    }}
                  />
                ))
            ) : (
              <div className="p-3">
                <p style={{ textAlign: 'center', color: 'var(--bs-gray-600)' }}>
                  Không có kết quả tìm kiếm phù hợp{' '}
                </p>
              </div>
            )}
            <Pagination
              onTop={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              setPage={setPageIndex}
              totalPages={members.totalPage}
              currentPage={members.currentPage}
            />
          </article>
        </div>
      </section>
    </div>
  );
};

export default ListMemberScreen;
